import UserRole from "../../slices/settings/user_role/UserRole"
import Module from "../../slices/settings/module/Module"
import Action from "../../slices/settings/action/Action"
import Permission from "../../slices/settings/permission/Permission"
import EntityPermission from "../../slices/settings/entity_permission/EntityPermission"
import AccountsInvoice from "../../slices/settings/global_control/AccountsInvoice"
import MfaSetup from "../../slices/settings/global_control/MfaSetup"
import EmailConfiguration from "../../slices/settings/global_control/EmailConfiguration"
import SmsConfiguration from "../../slices/settings/global_control/SmsConfiguration"
import PaymentGatewayConfig from "../../slices/settings/global_control/PaymentGatewayConfig"
import IpAccess from "../../slices/settings/IpAccess"

const settingsReducer = {
    userRole: UserRole,
    module: Module,
    action: Action,
    permission: Permission,
    entityPermission: EntityPermission,
    accountsInvoice: AccountsInvoice,
    mfaSetup: MfaSetup,
    emailConfiguration: EmailConfiguration,
    smsConfiguration: SmsConfiguration,
    paymentGatewayConfig: PaymentGatewayConfig,
    ipAccess: IpAccess,
};

export default settingsReducer;